import { Box, Typography } from "@mui/material";

// Zone name on a control card. The card keeps its fixed size, so the name gets a
// fixed space between the icon and the button. The page is used on tablets (no
// hover), so the name has to be readable on the card itself:
// - longer names get a smaller font (by length) and, above 20 characters, a third
//   line; only names longer than about 50 characters end in "…"
// - lines are balanced ("CHECKOUTS 1 / AND 2", not "CHECKOUTS 1 AND / 2")
// - with a mouse the full name also shows on hover (title attribute on the card)

const titleLayoutForName = (name) => {
  const length = String(name || "").length;
  if (length <= 12) return { fontSize: "0.92rem", lines: 2, lineHeight: 1.2 };
  if (length <= 20) return { fontSize: "0.8rem", lines: 2, lineHeight: 1.2 };
  return { fontSize: "0.7rem", lines: 3, lineHeight: 1.15 };
};

const ControlCardTitle = ({ name }) => {
  const layout = titleLayoutForName(name);

  return (
    <Box
      sx={{
        flex: "1 1 0",
        minHeight: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        mb: 1,
      }}
    >
      <Typography
        variant="h6"
        component="h2"
        sx={{
          fontSize: layout.fontSize,
          fontWeight: "bold",
          lineHeight: layout.lineHeight,
          textAlign: "center",
          overflowWrap: "anywhere",
          textWrap: "balance",
          display: "-webkit-box",
          WebkitBoxOrient: "vertical",
          WebkitLineClamp: layout.lines,
          overflow: "hidden",
        }}
      >
        {name}
      </Typography>
    </Box>
  );
};

export default ControlCardTitle;
